import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {computeGameDeadline, isFollowingGameExpired} from '../../../helpers/misc';
import {useHistory} from 'react-router';
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import DoneIcon from "@material-ui/icons/Done";
import {storeSelectedGame} from '../../../slices/selected';
import {useTranslation} from 'react-i18next';
import {selectUser} from '../../../slices/profile';
import {gameRequests, ROUTES} from '../../../db/models/const';
import { whenStudentFollowedRmTimestamp } from '../../../helpers/student';
import { docTimestampToString } from '../../../helpers/time';
import {Button} from "react-bootstrap";

export const FollowGameBrief = ({game}) => {
    const dispatch = useDispatch();
    const title = game?.title || "";
    const [request, setRequest] = useState();
    const task = game?.task || "";
    const [deadline, setDeadline] = useState();
    const history = useHistory();
    const user = useSelector(selectUser);
    const [attendance, setAttendance] = useState("");
    const {t} = useTranslation();
    const [isExpired, setIsExpired] = useState();

    useEffect(() => {
        if (!game) return;

        const request = gameRequests.find(request => request.id === game.request);
        setRequest(t(request?.label));
    }, [game])

    useEffect(() => {
        if (!game || !user) return;

        const followingAt = whenStudentFollowedRmTimestamp(user, game.rmId);
        setIsExpired(isFollowingGameExpired(game, followingAt));
        setDeadline(computeGameDeadline(game, followingAt));
    }, [game, user])

    useEffect(() => {
        const studentGames = user?.games || [];
        const studentWins = user?.wins || [];

        const found = studentGames.find(studentGame => studentGame.id === game.id);
        if (!found)
            setAttendance("-");
        else
            setAttendance(docTimestampToString("DD/MM/YY",found.created))
    }, [user, game]);

    const onGameClick = () => {
        if (!game) return;
        dispatch(storeSelectedGame({game}));
        history.push(ROUTES.FOLLOW_GAME.replace(":rmId", game.rmId));
    }

    return (
        <div className={`card followGameBrief ${isExpired ? "expired" : ""}`}>
            <h2>{title}</h2>
            <div className="item">
                <label>{t("student_follow_game_request")}</label>
                <p>{request}</p>
            </div>
            <div className="item">
                <label>{t("student_follow_game_task")}</label>
                <p>{task}</p>
            </div>
            <div className="item">
                <label>{t("student_follow_game_deadline")}</label>
                <p>{deadline}</p>
            </div>
            <div className="item">
                <label>{t("student_follow_game_attendance")}</label>
                <p>{attendance}</p>
            </div>
            {!isExpired && <Button onClick={() => onGameClick()}>{t("student_follow_game_buttonText")}</Button>}
        </div>
    )
}
